import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { PermissionChecker } from '../../session'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import { useTabsOptions } from './tabs/_data/tabsOptions'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import PublicTokenLoader from './_load/PublicTokenLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'

const PublicTokenModal = props => {
  const tabsOptions = useTabsOptions()

  return (
    <ControlledModal width="48rem" {...props}>
      <PermissionChecker any={['listPublicToken']}>
        <PublicTokenLoader>
          <TabsContext options={tabsOptions}>
            <ModalHeader />
            <HorizontalLine thin lineColor={COLORS.light2} />
            <Separator weight={6} />
            <TabsContent />
          </TabsContext>
        </PublicTokenLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default PublicTokenModal
